<template>
  <div class="crm-header-container">
    <el-row class="crm-header-content">
      <el-col :span="7" class="pl-6" @click.native="$emit('onClickLeftBtn')">
        <div class="crm-header-btn">
          <div v-show="iconLeftBtn">
            <i v-if="!isIconLeftBtnFromFile" :class="iconLeftBtn" />
            <img
              v-else
              :src="require(`@/assets/icon/${iconLeftBtn}`)"
              width="24"
            />
          </div>
        </div>
      </el-col>
      <el-col :span="10">
        <div v-if="title" class="crm-title-text">{{ title }}</div>
      </el-col>
      <el-col :span="7" class="pr-6" @click.native="$emit('onClickRightBtn')">
        <div class="crm-header-btn crm-header-btn-right">
          <div v-if="['login', 'register'].includes(currentRouteName.toLowerCase())">
            <el-dropdown @command="handleCommand" trigger="click">
              <span class="crm-header-flex-center">
                <div class="crm-header-flex-center">
                  <img width="20" :src="require(`@/assets/icons/${$i18n.locale == 'th' ? 'c-flag-thai.png' : 'c-flag-en.png'}`)" style="margin-right: 8px; border-radius:50%;"/>
                </div>
                {{$i18n.locale.toUpperCase()}}
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="th">
                  <span class="crm-header-flex-center"><img width="30" :src="require('@/assets/icons/flag-thai.png')" style="margin-right: 10px;"/>ภาษาไทย<img v-if="$i18n.locale == 'th'" :src="require('@/assets/icon/check.png')" style="margin-left: 30px;"/></span>
                </el-dropdown-item>
                <el-dropdown-item command="en" divided>
                  <span class="crm-header-flex-center"><img width="30" :src="require('@/assets/icons/flag-en.png')" style="margin-right: 10px;"/>English<img v-if="$i18n.locale == 'en'" :src="require('@/assets/icon/check.png')" style="margin-left: 30px;"/></span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div v-show="iconRightBtn">
            <i v-if="!isIconRightBtnFromFile" :class="iconRightBtn" />
            <img
              v-else
              :src="require(`@/assets/icon/${iconRightBtn}`)"
              width="24"
            />
          </div>
        </div>
      </el-col>
    </el-row>
    <slot />
  </div>
</template>

<script>
export default {
  name: "MainHeader",
  props: {
    title: String,
    points: {
      type: Number,
      default: () => 0,
    },
    iconLeftBtn: String,
    isIconLeftBtnFromFile: Boolean,
    iconRightBtn: String,
    isIconRightBtnFromFile: Boolean,
  },
  methods: {
    handleBack() {
      this.$router.go(-1);
    },
    handleCommand(command) {
      this.changeLang(command)
    },
    changeLang(lang) {
      if (this.$i18n.locale !== lang) {
        this.$i18n.locale = lang
        localStorage.setItem('lang', lang)
        this.$router.go(0)
      }
    }
  },
  computed: {
    currentRouteName() {
      return this.$route.name;
    }
  }
};
</script>

<style scoped>
.crm-header-container {
  background-image: url("../assets/svg/background.svg?inline");
  background-repeat: no-repeat;
  background-color: var(--primary);
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  min-height: 100vh;
}

.crm-header-content {
  display: flex;
  align-items: center;
  height: var(--header-height);
}

.crm-header-btn {
  /* margin-top: 55px; */
  height: 24px;
  font-size: 24px;
  color: #ffffff;
}

.crm-header-btn-right {
  float: right;
}

.crm-title-text {
  /* margin-top: 60px; */
  font-weight: 500;
  font-size: 24px;
  line-height: 16px;
  color: #ffffff;
  text-align: center;
  width: 100%;
}

.crm-header-flex-center {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}

.el-dropdown-selfdefine {
  font-size: 16px;
  color: #ffffff;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.el-dropdown-menu__item {
  padding: 0 12px;
}

.el-dropdown-menu__item--divided:before {
  margin: 0;
}
</style>
